import * as z from "zod";

// Wind down the team's RESOLVE enrollment (§5.5.10) — the settings toggle's
// "off". `status` is our outcome; `error` carries Disputely's RFC-7807 detail on
// failure. A benign already-inactive 409 still reports `unenrolled`.
export const unenrollDisputelyResolve = {
  name: "unenrollDisputelyResolve" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    status: z.enum(["unenrolled", "failed"]),
    error: z.string().optional(),
  }),
};
